import React from "react";
import Icon from "@mdi/react";
import { mdiChevronRight } from "@mdi/js";
import { Link } from "react-router-dom";

// Shared section heading for the v2 landing page: title + subtitle on the left,
// optional "View all" link on the right.
const SectionHeader: React.FC<{ title: React.ReactNode; subtitle?: string; viewAllHref?: string }> = ({ title, subtitle, viewAllHref }) => (
  <div className="v2-section__header">
    <h2 className="v2-section__title">{title}</h2>
    {subtitle && <p className="v2-section__subtitle">{subtitle}</p>}
    {viewAllHref && (
      <Link to={viewAllHref} className="v2-section__viewall">
        View all <Icon path={mdiChevronRight} size="20px" />
      </Link>
    )}
  </div>
);

export default SectionHeader;
